"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _image = require("@qwkin/image");
var _reactEasyCrop = _interopRequireDefault(require("react-easy-crop"));
var _core = require("@material-ui/core");
var _styledComponents = require("styled-components");
var _theme = require("../utils/theme");
var _ImageCropper = require("./ImageCropper.styles");
var _Text = require("../Text");
var _Icon = require("../Icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ImageCropper = function ImageCropper(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    onCropFinished = _ref.onCropFinished,
    src = _ref.src,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? 25 / 14 : _ref$aspectRatio;
  var _useState = (0, _react.useState)({
      x: 0,
      y: 0
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    crop = _useState2[0],
    setCrop = _useState2[1];
  var _useState3 = (0, _react.useState)(1),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    zoom = _useState4[0],
    setZoom = _useState4[1];
  var onCropComplete = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(croppedArea, croppedAreaPixels) {
      var croppedImage, croppedImageBlober, blob;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _image.getCroppedImg)(src, croppedAreaPixels);
          case 3:
            croppedImage = _context.sent;
            _context.next = 6;
            return fetch(croppedImage);
          case 6:
            croppedImageBlober = _context.sent;
            _context.next = 9;
            return croppedImageBlober.blob();
          case 9:
            blob = _context.sent;
            blob.originalName = 'blob';
            blob.name = 'blob';
            blob.lastModified = new Date();
            onCropFinished(blob);
            _context.next = 19;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 16]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    weight: "bold",
    style: {
      margin: '8px 0'
    }
  }, "Crop Image"), /*#__PURE__*/_react["default"].createElement(_ImageCropper.CropperContainer, null, /*#__PURE__*/_react["default"].createElement(_reactEasyCrop["default"], {
    image: src,
    crop: crop,
    zoom: zoom,
    aspect: aspectRatio,
    onCropChange: setCrop,
    onCropComplete: onCropComplete,
    onZoomChange: setZoom,
    style: {
      containerStyle: {
        borderRadius: '10px'
      }
    }
  })), /*#__PURE__*/_react["default"].createElement(_ImageCropper.SliderContainer, null, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    icon: "gallery",
    size: 18,
    style: {
      marginRight: '16px'
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Slider, {
    value: zoom,
    min: 1,
    max: 3,
    step: 0.1,
    "aria-labelledby": "Zoom",
    onChange: function onChange(e, zoom) {
      return setZoom(zoom);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    icon: "gallery",
    size: 25,
    style: {
      marginLeft: '16px'
    }
  })));
};
var _default = exports["default"] = ImageCropper;